import { ChipsideComponent } from "../chipside-component";

export class AccordionItem extends ChipsideComponent {
	static observedAttributes = ["open"];

	constructor() {
		super();

		this.heading = this.getAttribute("heading") ?? "";
		this.open = this.hasAttribute("open");
	}

	parsedCallback() {
		this.appendChild(document.createElementWithContents("div", this.childNodes, {
			className: "accordion__content"
		}));

		const button = document.createElementWithContents("button", this.heading, {
			className: "btn--base btn-accordion-toggle",
			type: "button",
			ariaExpanded: this.open,
			onclick: () => this.open = !this.open
		}), toggleIcon = document.createElementWithContents("i", null, {
			className: "fas fa-chevron-down accordion__icon"
		});

		if (this.closest("chip-accordion")) {
			button.appendChild(toggleIcon);
		} else {
			button.prepend(toggleIcon);
		}

		this.prepend(button);
	}

	attributeChanged(name, _, newValue) {
		if (name === "open") {
			if (this.IsAttributeValueTrue(newValue)) {
				this.Open();
			} else {
				this.Close();
			}
		}
	}

	#GetItems() {
		const container = this.closest("chip-accordion");

		if (container && !container.multiple) {
			return [...container.querySelectorAll("chip-accordionitem") ?? []];
		} else {
			return [this];
		}
	}

	Open() {
		this.#GetItems().filter(x => x !== this && x.open).forEach(x => x.Close());

		this.querySelector(".btn-accordion-toggle").ariaExpanded = true;
		this.open = true;
	}

	Close() {
		this.querySelector(".btn-accordion-toggle").ariaExpanded = false;
		this.open = false;
	}
}